export const ADMIN_EMAIL = 'kyle@chaplin.us';

export const isAdminEmail = (email?: string | null): boolean =>
  email?.trim().toLowerCase() === ADMIN_EMAIL;
